
<th
	ref="th"
	:style="style"
	:data-clickable="clickable"
	:data-hover="hover"
	@mouseover="handleHover"
	@mouseout="handleHover"
>
	<slot />
</th>
